import { ModalBasic } from '@npco/zeller-design-system'

import { NoAccounts } from 'components/Placeholders/NoAccounts/NoAccounts'

export const NoAccountsForSelectAccountForm = () => (
  <ModalBasic.Body data-testid="no-accounts-modal-body">
    <NoAccounts />
  </ModalBasic.Body>
)
